const baseURL = "https://test.hypersocio.com";
//const baseURL = "http://localhost:3000";

module.exports = {
    baseURL: baseURL
};

